import React from "react";
import HamburgerButton from "./hamburgerButton";
import Sidebar from "./sidebar";
import RingConnect from "../../assets/ringconnect";
import HeaderMenuRight from "./headerMenuRight";
import StickyHeader from "./stickyHeader";
import HeaderText from "./headerText";

export default function Header() {
  return (
    <StickyHeader className="z-[99] py-5 xl:py-5 3xl:px-8 4xl:px-10">
      <div className="flex w-full max-w-2xl items-center">
        <HamburgerButton
          view={<Sidebar className="static w-full 2xl:w-full" />}
          className="text-primary-dark"
          placement="left"
          containerClassName="!w-[278px]"
        />
        <a
          href={"/"}
          aria-label="Site Logo"
          className="me-4 w-9 shrink-0 text-gray-800 hover:text-gray-900 lg:me-5 xl:hidden"
        >
          <RingConnect className="h-[25px] w-[190px]" />
        </a>
        <HeaderText />
      </div>

      <HeaderMenuRight />
    </StickyHeader>
  );
}
